import imgHandle from '../helpers/imgHandle';
import {uploadToken} from './Cache';

export default async (files, imgOptions, ajaxOptions = {}, uploadPath, drive) => {
    if (!ajaxOptions.onUploadProgress) {
        ajaxOptions.onUploadProgress = (e) => {
            // console.log(parseInt((e.loaded / e.total).toFixed(2) * 100));
        };
    }

    const uploadParameter = await uploadToken(drive);
    const uploadForm = uploadParameter.form;
    if (uploadPath) uploadPath += '/';
    if (!uploadPath) uploadPath = '';

    console.log(uploadParameter);

    const filesUrl = [];
    for (let i = 0; i < files.length; i++) {
        let file = files[i];
        if (file.type.includes('image') && !file.type.includes('gif') && imgOptions) {
            const newFile = await imgHandle(file, imgOptions);
            newFile.name = file.name;
            file = newFile;
        }

        const ext = file.name.split('.').pop();
        const filename = `${(new Date()).getTime()}.${ext}`;
        uploadPath += filename;

        const formData = new FormData();
        for (const key in uploadForm) {
            if (!{}.hasOwnProperty.call(uploadForm, key)) continue;
            formData.append(key, uploadForm[key]);
        }

        formData.append('Access-Control-Request-Method', 'post');
        formData.append('OSSAccessKeyId', uploadParameter.accessId);
        formData.append('policy', uploadParameter.policy);
        formData.append('signature', uploadParameter.signature);
        formData.append('key', uploadPath);
        formData.append('file', file);
        formData.append('success_action_status', 200);

        await axios.post(uploadParameter.host, formData, ajaxOptions);

        filesUrl.push(`${uploadParameter.host}/${uploadPath}`);
    }
    return filesUrl;
};
